<template>
  <base-card @close="close">
    <div id="contract-creation-wrapper">
      <heading heading="Add Contract" />
      <div id="contract-horizontal">
        <div id="contract-section-one" class="contract-section">
          <Input
            class="scs-input"
            heading="Contract Name"
            placeholder="Contract Name"
            :initialValue="subject.contractName"
            @scs-input="nameInput"
          />

          <TextArea
            class="scs-input"
            heading="Body"
            type="number"
            :initialValue="subject.contractBody"
            placeholder="20"
            @scs-input="bodyInput"
          />
        </div>
        <div id="contract-section-two" class="contract-section">
          <p v-html="mergeTagInformation"></p>
        </div>
      </div>
      <div class="button-container">
        <Button text="Back" @click="close" :processing="processing" /><Button
          text="Next"
          @click="next"
          :processing="processing"
        />
      </div>
    </div>
  </base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import Input from "@/Components/Elements/Input.vue";
import TextArea from "@/Components/Elements/TextArea.vue";

export default {
  data() {
    return {
      subject: {
        contractName: undefined,
        contractBody: undefined,
        id: "contract" + Date.now(),
      },
      errors: {
        name: false,
        body: false,
      },
      mergeTagInformation:
        "Use the following merge tags to personalize your emails to your contacts: <br/><b><br/>Signer First Name: {given_name}<br/> Signer Last Name: {family_name}<br/> Event Start Time: {event-start-time}<br/> Event End Time: {event-end-time}<br/> Event Length: {event-length}<br/> Event Date: {event-date}<br/> Event Title: {event-title}<br/> Invoice Total: {invoice-total}<br/> Invoice Subtotal: {invoice-subtotal}<br/> Invoice Adjustments: {invoice-adjustments}<br/> Invoice Final Payment Due: {invoice-final-payment-due}<br/> Invoice Deposit Amount: {invoice-deposit-amount}<br/> Client List: {client-list}<br/> Location List: {location-list}<br/> Business Name: {business-name}<br/> </b><br/>Be sure to include the brackets {}. Otherwise, the tag will not be replaced.",
    };
  },
  methods: {
    next() {
      this.addContract();
    },
    close() {
      this.$emit("close");
    },
    async addContract() {
      this.$emit("add-contract", this.subject);
    },
    nameInput(value) {
      this.subject.contractName = value;
    },
    bodyInput(value) {
      this.subject.contractBody = value;
    },
  },
  components: {
    BaseCard,
    Button,
    Heading,
    Input,
    TextArea,
  },
  created() {
    if (this.contract) {
      this.subject = { ...this.contract };
    }
  },
  props: ["contract", "mode", "processing"],
  emits: ["close", "add-contract"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  .scs-button {
    margin: 5px;
  }

  #contract-inputs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 0 0 30px;
  }

  #contract-horizontal {
    height: 50vh;
    overflow: scroll;
    display: flex;
    flex-direction: column;
  }

  .contract-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  p {
    text-align: left;
    width: 100%;
  }

  .scs-input {
    margin: 20px 0;
  }
  @media (min-width: 800px) {
    #contract-horizontal {
      flex-direction: row;
    }

    .contract-section {
      width: 50%;
    }

    p {
      width: 80%;
    }

    .scs-input {
      width: 300px;
    }
  }
}
</style>
